import { asyncRouterMap, constantRouterMap, page_error } from "@/router";
import router, { resetRouter } from "../../router";
import { deepClone } from '@/utils/index'
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route, path, isSuper) {
  if (isSuper) return true;
  if (route.path) {
    const fullPath = `${path}${route.authPath || route.path}`;
    return roles.some(
      (role) => role.isMenu == true && fullPath.indexOf(role.path) >= 0
    );
  } else {
    return true;
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles, path, isSuper) {
  const accessedRouters = asyncRouterMap.filter((route) => {
    if (route.children && route.children.length > 0) {
      const path2 = `${path}${route.path}/`;
      route.children = filterAsyncRouter(route.children, roles, path2, isSuper);
      // console.log(route)
      if (route.children.length == 0) {
        // console.log(route)
        return false;
      }
      return true;
    } else {
      // 超级管理员，拥有全部菜单权限
      if (isSuper) {
        return true;
      }
      // 当前菜单隐藏，则不进行角色菜单处理
      // if (route.hidden) {
      //   return false;
      // }
      return hasPermission(roles, route, path, isSuper);
    }
  });
  return accessedRouters;
}

function generateRouter({ allMenus, flatRoleMenus }) {
  console.log(allMenus, "allMenus==");
  console.log(flatRoleMenus, "flatRoleMenus==");
  const temp = [];
  const forFn = function ({ arr = [], parentMenu = {}, parentPath = "" }) {
    for (let menu of arr) {
      if (menu.children && menu.children.length) {
        forFn({
          arr: menu.children,
          parentMenu: menu,
          parentPath: menu.path
        });
      } else {
        const fullPath = `${parentPath}/${menu.path}`;
        for (const item of flatRoleMenus) {
          if (item.path == fullPath) {
            const { children, ...rest } = parentMenu;
            const index = temp.findIndex((e) => e.path == parentPath);
            if (index > -1) {
              temp[index].children.push(item);
            } else {
              temp.push({ ...rest, children: [item] });
            }
          }
        }
      }
    }
  };
  forFn({ arr: allMenus, parentMenu: {}, parentPath: "" });
  console.log(temp, "temp===");
  return temp;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    removeRouters: [],
    done: false
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      resetRouter()
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
      routers.map((e) => {
        router.addRoute(e);
      });
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise((resolve) => {
        const { roles, isSuper } = data;
        let accessedRouters;
        accessedRouters = filterAsyncRouter(deepClone(asyncRouterMap), roles, "", isSuper);
        console.log(accessedRouters, "accessedRouters===");
        commit("SET_ROUTERS", [...accessedRouters, ...page_error]);
        resolve();
      });
    }
  }
};

export default permission;
